<template id="modal-template">
    <transition v-if="show" name="modal" appear>
        <div class="modal-container modal-container--scrollable">
            <div class="modal-wrapper">
                <div class="modal">
                    <button class="modal__close" type="button" @click="close">
                        <icon-base
                            viewBox="0 0 40.2 40"
                            icon-name="close-rounded"
                        ><close-rounded/>
                        </icon-base>
                    </button>
                    <div class="modal__head">
                        <h1 class="modal__title">상품문의등록</h1>
                    </div>
                    <div class="modal__body">
                        <div class="modal-inquiry-container">
                            <div class="modal-inquiry">
                                <h2 class="modal-inquiry__name"></h2>
                                <div class="modal-inquiry__form">
                                    <div class="modal-inquiry__form-row">
                                        <select v-model="inquire.type" class="select">
                                            <option :value="null">문의유형을 선택해주세요</option>
                                            <option value="상품">상품</option>
                                            <option value="배송">배송</option>
                                            <option value="기타">기타</option>
                                        </select>
                                    </div>
                                    <div class="modal-inquiry__form-row">
                                        <input v-model="inquire.subject" class="input" type="text" name="" value="" placeholder="문의 제목을 입력해주세요.">
                                    </div>
                                    <div class="modal-inquiry__form-row">
                                        <textarea v-model="inquire.content" class="textarea" name="name" placeholder="문의 내용을 입력해주세요."></textarea>
                                    </div>
                                    <div class="modal-inquiry__form-row">
                                        <label class="check">
                                            <input v-model="inquire.secret" class="input" type="checkbox" name="" :value="true">
                                            <i class="icon"></i>
                                            <span class="text">비공개</span>
                                        </label>
                                    </div>
                                    <div v-for="(image, index) in inquire.images" :key="index" class="modal-inquiry__form-row">
                                        <input type="file" @change="inquire.images[index] = $event.target.files[0]" accept="image/*">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal__foot modal__foot--border">
                        <div class="modal__buttons">
                            <button class="button button--primary" type="button" @click="submit"><span>문의하기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from "@/api";

export default{
    props: {
        purchase: { type: Object, default: null },
        product: { type: Object, default: null },
    },
    data(){
        return {
            show: false,

            inquire: {
                _product: (this.$props.purchase || {})._product || (this.$props.product || {})._id,
                _store: (this.$props.purchase || this.$props.product || {})._store,
                type: null,
                subject: null,
                content: null,
                secret: false,
                images: new Array(5)
            }
        }
    },
    methods: {
        open(){
            this.show = true;
            document.querySelector('html').setAttribute('data-modal', 'opened');
        },
        close(){
            this.show = false;
            document.querySelector('html').removeAttribute('data-modal');
        },
        async submit(){
            try{
                var { inquire } = await api.v1.me.inquires.postInquire(this.inquire);

                for(var index in this.inquire.images){
                    if(this.inquire.images[index]) await api.v1.me.inquires.postImage(inquire, this.inquire.images[index], index);
                }

                alert("문의가 완료되었습니다");
                this.$emit('submit');
                this.close();
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    watch: {
        purchase(){
            this.inquire._product = this.purchase._product;
            this.inquire._store = this.purchase._store;
        }
    }
}
</script>
